import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import type { AdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { PaywalledAdvisorAction } from '@src/components/sco/Advisors/shared/PaywalledAdvisorAction';
import { AdvisorMarketplaceAction, advisorMarketplaceActionHref } from '@src/components/sco/Advisors/utils/advisorMarketplaceActions';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type AdvisorMarketplaceActionButtonProps = {
  action: AdvisorMarketplaceAction;
  userId: string;
  paths: Pick<AdvisorsPaths, 'sessionNew' | 'inbox' | 'profile' | 'withQuery'>;
  slug?: string | null;
  onInvite?: () => void;
};

/** Directory / profile CTA. Message and Invite are gated behind the $49 `canAccessChat` paywall. */
export const AdvisorMarketplaceActionButton = t0 => {
  const $ = _c(16);
  const {
    action,
    userId,
    paths,
    slug,
    onInvite
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== paths || $[2] !== slug || $[3] !== userId) {
    t1 = advisorMarketplaceActionHref(action, userId, paths, slug);
    $[0] = action;
    $[1] = paths;
    $[2] = slug;
    $[3] = userId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const href = t1;
  let t2;
  if ($[5] !== action.key || $[6] !== action.label || $[7] !== action.variant || $[8] !== href || $[9] !== onInvite) {
    t2 = href ? <Button asChild={true} size="sm" variant={action.variant} width="full" onClick={_temp}><NextLink href={href}>{action.label}</NextLink></Button> : action.key === "invite" ? <Button size="sm" variant={action.variant} width="full" onClick={event_0 => {
      event_0.stopPropagation();
      onInvite?.();
    }}>{action.label}</Button> : null;
    $[5] = action.key;
    $[6] = action.label;
    $[7] = action.variant;
    $[8] = href;
    $[9] = onInvite;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const button = t2;
  if (action.key === "message" || action.key === "invite") {
    const t3 = action.key === "invite" ? "advisor-invite" : "advisor-message";
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        size: "sm",
        width: "full",
        onClick: _temp2
      };
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    const t5 = action.key === "invite" ? "Upgrade to Invite" : "Upgrade to Message";
    let t6;
    if ($[12] !== button || $[13] !== t3 || $[14] !== t5) {
      t6 = <PaywalledAdvisorAction intent={t3} upgradeCtaButtonProps={t4} upgradeCtaLabel={t5}>{button}</PaywalledAdvisorAction>;
      $[12] = button;
      $[13] = t3;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  return button;
};
function _temp(event) {
  return event.stopPropagation();
}
function _temp2(event_1) {
  return event_1.stopPropagation();
}